
import { mapGetters } from 'vuex'
export default {
    data() {
        return {}
    },
    computed: {
        ...mapGetters({
            loading: 'themes/player-bank/loading',
            bankAccount: 'themes/player-bank/bankAccount',
        }),
    },
    methods: {
        onEditBankAccount(item) {
            this.$router.push('/payment-methods/edit/bank/' + item.id)
        },
    },
}
